import { render, staticRenderFns } from "./Medicine.vue?vue&type=template&id=04c1ef47"
import script from "./Medicine.vue?vue&type=script&lang=js"
export * from "./Medicine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-pharmacy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04c1ef47')) {
      api.createRecord('04c1ef47', component.options)
    } else {
      api.reload('04c1ef47', component.options)
    }
    module.hot.accept("./Medicine.vue?vue&type=template&id=04c1ef47", function () {
      api.rerender('04c1ef47', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/manager/pharmacy/pharmacy/Medicine.vue"
export default component.exports